<template>
	<div class="modal" id="avaliability-modal">
		<img
			:src="controlinnLogo"
			v-if="isLoading"
		/>
		<div
			class="modal-header-date"
			v-else
		>
			<span>{{initDate}}</span>
			<span class="total-nights">{{totalNights}} Noches</span>
			<span>{{endDate}}</span>
		</div>
		<div
			class="modal-content"
			v-if="!isLoading"
		>
			<div class="rooms-quantity">
				<p># Reservas</p>
				<v-flex xs4>
					<input-text v-model.number="roomQuantity" type="number"/>
				</v-flex>
			</div>
			<div
				class="type-room"
				v-for="(room, indexRoom) in roomsType"
				:key="indexRoom"
			>
				<p class="room">{{room.name}}</p>
				<p class="avaliability">{{room.total}}</p>
				<v-flex class="reservation-btn xs4">
					<v-btn
						class="btn-save"
						:disabled="!avaliabilityCero"
						@click="goToReserve(initDate, endDate, subsidiary, room, roomQuantity)"
					>
						Reservar
					</v-btn>
				</v-flex>
			</div>
		</div>
	</div>
</template>
<script>
import mixin from '@/shared/mixins';
import inputText from '@/clerkinn/shared/input-text';

function mounted() {
	const index = this.calculatePosition;
	const displaceModal = (index * this.blockWidth) + ((this.blockWidth - this.modalWidth) / 2);
	const ele = document.getElementById('avaliability-modal');
	ele.style.transform = `translateX(${displaceModal}px)`;
}

function avaliabilityCero() {
	return this.roomQuantity && this.roomQuantity > 0;
}

function goToReserve(initDate, endDate, hotelId, { id, total }, reservation) {
	const numReserve = reservation;
	const todayMiliseconds = Date.parse(new Date());
	const initDateMiliseconds = Date.parse(new Date(initDate));
	if (todayMiliseconds < initDateMiliseconds) {
		const query = {
			initDate,
			endDate,
			hotelId,
			roomTypeId: id,
			numReserve,
		};
		if (reservation === 1) {
			this.$router.push({ name: 'booking-new', query });
		} else {
			this.$router.push({ name: 'select-rooms', query });
		}
	} else {
		this.showNotification('No se pueden crear reservas en fechas anteriores a la actual. Modifica tu selección.', 'error');
	}
}

function data() {
	return {
		blockWidth: 43,
		controlinnLogo: '/static/img/logo-control-inn.png',
		modalWidth: 230,
		rooms: [1, 2, 3, 4, 5, 6, 7, 8, 9],
		roomQuantity: null,
	};
}

export default {
	name: 'avaliability-modal',
	components: {
		inputText,
	},
	computed: {
		avaliabilityCero,
	},
	data,
	methods: {
		goToReserve,
	},
	mixins: mixin,
	mounted,
	props: {
		calculatePosition: {
			default: null,
			type: Number,
		},
		endDate: {
			default: '',
			type: String,
		},
		initDate: {
			default: '',
			type: String,
		},
		isLoading: {
			deafult: false,
			type: Boolean,
		},
		roomsType: {
			default: () => [],
			type: Array,
		},
		subsidiary: {
			default: 0,
			type: Number,
		},
		totalNights: {
			default: '',
			type: [String, Number],
		},
	},
};
</script>
<style lang="scss" scoped>
	.modal {
		align-items: center;
		background-color: map-get($colors, default-bg);
		border-radius: 6px;
		bottom: 2.5em;
		display: flex;
		flex-direction: column;
		height: 240px;
		justify-content: center;
		padding: 3px 10px;
		position: absolute;
		width: 230px;
		z-index: 2;
	}

	.modal::before {
		bottom: -16px;
		border-color: transparent;
		border-style: solid solid outset;
		border-top-color: map-get($colors, default-bg);
		border-width: 8px;
		content: " ";
		display: block;
		height: 0;
		left: 107px;
		position: absolute;
		width: 0;
	}

	.modal-header-date {
		align-items: center;
		color: map-get($colors, border-tooltip);
		display: flex;
		font-family: map-get($fonts, medium);
		font-size: map-get($sizes, twelve);
		justify-content: space-between;
		margin-bottom: 5px;
		width: 100%;
	}

	.total-nights {
		background-color: black;
		color: white;
		font-family: map-get($fonts, semibold);
		padding: 0 3px;
	}

	.modal-content {
		background-color: white;
		height: 100%;
		padding: 6px 15px;
		width: 100%;
	}

	.type-room {
		align-items: center;
		border-top: 2px solid map-get($colors , border-radio);
		color: map-get($colors, border-tooltip);
		display: flex;
		height: 36px;
		justify-content: space-between;
		padding: 0 5px;

		p {
			margin: 0;
		}
	}

	.reservation-btn {
		height: 23px;

		button.btn {
			height: 100%;
		}
	}

	.btn-save {
		min-width: 100% !important;
	}

	.room {
		width: 55px
	 }
	 
	 .rooms-quantity {
		 align-items: center;
		 display: flex;
		 justify-content: space-between;
		 padding: 0 5px;

		 p {
			margin: 0;
			white-space: nowrap;
    		width: auto;
		 }
	 }
</style>




// WEBPACK FOOTER //
// AvaliabilityModal.vue?7d9f5893